import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { ThomasMainData } from 'models/interfaces';

const LIST_THOMASMAIN_QUERY = gql`
  query ListThomasMain($keyword: String!) {
    thomasMainLike(keyword: $keyword) {
      acct
      publish_name
      company
      thomasAdvertiser {
        tgrams_id
        name
      }
    }
  }
`;
interface ThomasMainContainerProps {
  data?: ThomasMainData;
}

interface ThomasContainerProps {
  keyword: string;
  children: (props: ThomasMainContainerProps) => any;
}

//class ThomasMainQuery extends Query<ThomasMainData, any> {}

const ThomasAdvertiserListContainer: React.FunctionComponent<ThomasContainerProps> = ({
  keyword,
  children,
  ...props
}) => (
  <Query<ThomasMainData, any>
    query={LIST_THOMASMAIN_QUERY}
    variables={{ keyword }}
    fetchPolicy={'no-cache'}
  >
    {({ data, loading, error }) => {
      if (loading || error) {
        return null;
      }
      return (
        children &&
        children({
          ...props,
          data
        })
      );
    }}
  </Query>
);

export default ThomasAdvertiserListContainer;
